module.exports = __webpack_public_path__ + "img/security-and-compliance.7997cf93.svg";